module.exports = __webpack_public_path__ + "HP_Latex_R530_big_poster.png?03a1f6572a54629d96b6fb3d87900d0e";